import {createSlice} from '@reduxjs/toolkit';
const initialState = {
   type: null,
   status: 'idle',
   pressClose: false,
   volume: 1,
};
const AslSlice = createSlice({
   name: 'asl',
   initialState,
   reducers: {
      setAsl: (state, action) => {
         state.status = action.payload.status;
         state.type = action.payload.type;
      },
      setType: (state, action) => {
         state.type = action.payload;
      },
      setPlayStatus: (state, action) => {
         state.status = action.payload;
      },
      setPressClose: (state, action) => {
         state.pressClose = action.payload;
      },
      setVolume: (state, action) => {
         state.volume = action.payload;
      },
   },
});
export const {setAsl, setType, setPlayStatus, setPressClose, setVolume} =
   AslSlice.actions;
export const selectAsl = state => state.asl;
export const selectAslStatus = state => state.asl.status;
export const selectAslType = state => state.asl.type;
export const selectAslPressClose = state => state.asl.pressClose;
export const selectAslVolume = state => state.asl.volume;
export default AslSlice.reducer;
